import React from "react";
import CategorySelect from "./CategorySelect";

const CategoryAddPopup = ({
  departments,
  level2,
  level3,
  pendingDept,
  pendingCat,
  pendingSub,
  setPendingDept,
  setPendingCat,
  setPendingSub,
  onAdd,
  canAdd,
}) => {
  return (
    <div className="chip-edit-popup">
      <div className="chip-edit-selects">
        <CategorySelect
          changeFunc={(val) => {
            setPendingDept(val);
            setPendingCat("");
            setPendingSub("");
          }}
          valName="מחלקה"
          filtersArr={departments}
          currVal={pendingDept}
        />

        {pendingDept && level2.length > 0 && (
          <CategorySelect
            changeFunc={(val) => {
              setPendingCat(val);
              setPendingSub("");
            }}
            valName="קטגוריה"
            filtersArr={level2}
            currVal={pendingCat}
          />
        )}

        {pendingCat && level3.length > 0 && (
          <CategorySelect
            changeFunc={setPendingSub}
            valName="תת קטגוריה"
            filtersArr={level3}
            currVal={pendingSub}
          />
        )}
      </div>

      <button className="chip-apply-btn" onClick={onAdd} disabled={!canAdd}>
        הוסף
      </button>
    </div>
  );
};

export default CategoryAddPopup;
